<div class="container">
  <div class="card offset xp">
    <h1>{{title}}</h1>

    <div class="border-bottom pb-4 mb-2">
      <a class="icon-btn fa-chevron-left"
        [attr.data-dl]="JSON.stringify({da_track: 'true'})"
        (click)="returnToCompletedRequests()">
        Return to Completed Requests
      </a>
    </div>



    <div class=" row report-info">
      <p class="col-md-4"><strong>Valuation Date:</strong> {{filterValuationDate}}</p>
      <p class="col-md-4"><strong>From:</strong> {{firstName}} {{lastName}}</p>
      <p class="col-md-4"><strong>Report Type:</strong> {{data.reportType}}</p>
    </div>




    <div *ngIf="totalRows !== 0"
      class="text-white bg-treo py-1 px-2 mb-3">Reports: {{totalRows}}</div>
    <ag-grid-angular style="width: 100%; height: 100%;"
      [rowData]="rowDataRes"
      [columnDefs]="columnDefs"
      [sortingOrder]="['asc', 'desc']"
      [defaultColDef]="defaultColDefNotify"
      [rowSelection]="'multiple'"
      [rowMultiSelectWithClick]="true"
      [suppressRowClickSelection]="true"
      [pagination]="totalRows > 10"
      [suppressCellFocus]="true"
      [paginationPageSize]="paginationPageSizeNotify"
      [paginationPageSizeSelector]="paginationPageSizeSelectorNotify"
      [gridOptions]="gridOptions"
      enableCellTextSelection=true
      class="ag-theme-quartz"
      (gridReady)="onGridReady($event)"
      overlayNoRowsTemplate="<span></span>"></ag-grid-angular>
    <div class="border-bottom text-center small py-2"
      *ngIf="totalRows === 0">No Reports found.</div>
    <div *ngIf="totalRows !== 0"
      class="text-white bg-treo py-1 px-2">Reports: {{totalRows}}</div>
  </div>
</div>


<app-reports-burst-grid-popup></app-reports-burst-grid-popup>